import { useAlertSubscription } from "@/api/hooks/alert";
import { FormField } from "@/overlay/components/form-field";
import { t } from "@lingui/core/macro";

type AlertSubscriptionDetailsProps = {
  subscriptionId: string;
};

function formatLocation({
  location_label,
  location_lat,
  location_lon,
}: {
  location_label?: string | null;
  location_lat?: number | null;
  location_lon?: number | null;
}) {
  const coordinates = location_lat != null && location_lon != null ? `${location_lat}, ${location_lon}` : undefined;

  return [location_label, coordinates].filter(Boolean).join(" — ");
}

export function AlertSubscriptionDetails({ subscriptionId }: AlertSubscriptionDetailsProps) {
  const { subscription, isLoading, error } = useAlertSubscription(subscriptionId);

  if (!subscriptionId) {
    return <p>{t`No Alert Tool subscription is connected to this layer.`}</p>;
  }

  if (isLoading) {
    return <p>{t`Loading alert configuration…`}</p>;
  }

  if (error || !subscription) {
    return <p>{t`The alert configuration could not be loaded.`}</p>;
  }

  return (
    <>
      <FormField label={t`Subscription`}>
        <span>{subscription.name}</span>
      </FormField>
      <FormField label={t`Status`}>
        <span>{subscription.is_active ? t`Active` : t`Inactive`}</span>
      </FormField>
      <FormField label={t`Execution frequency`}>
        <span>{t`Every ${subscription.execution_frequency} minutes`}</span>
      </FormField>
      <FormField label={t`Locations`}>
        <span>{subscription.locations?.map(formatLocation).filter(Boolean).join(", ") || t`None`}</span>
      </FormField>
      <FormField label={t`Triggers`}>
        <span>{subscription.triggers?.length ?? 0}</span>
      </FormField>
    </>
  );
}
